import { FontFamily, FontWeight } from "../../models/shared/formats/Font";
// Font Family
export const fontFamilyByEncodedValue = {
  0: FontFamily.DEFAULT,
  4096: FontFamily.ARIAL,
  8192: FontFamily.TAHOMA,
  12288: FontFamily.TIMES,
  16384: FontFamily.VERDANA
};
export const encodedValueByFontFamily = {
  [FontFamily.DEFAULT]: 0,
  [FontFamily.ARIAL]: 4096,
  [FontFamily.TAHOMA]: 8192,
  [FontFamily.TIMES]: 12288,
  [FontFamily.VERDANA]: 16384
};

// Font Weight
export const fontWeightByEncodedValue = {
  0: FontWeight.DEFAULT,
  1: FontWeight.BOLD
};
export const encodedValueByFontWeight = {
  [FontWeight.DEFAULT]: 0,
  [FontWeight.BOLD]: 1
};

// Font Size
export const fontSizeByEncodedValue = {
  0: "default",
  65536: 8,
  131072: 9,
  196608: 10,
  262144: 12,
  327680: 14,
  393216: 16,
  458752: 18,
  524288: 20,
  589824: 24,
  655360: 28,
  720896: 32,
  786432: 36
};
export const encodedValueByFontSize = {
  8: 65536,
  9: 131072,
  10: 196608,
  12: 262144,
  14: 327680,
  16: 393216,
  18: 458752,
  20: 524288,
  24: 589824,
  28: 655360,
  32: 720896,
  36: 786432,
  default: 0
};

// Encode / Decode functions
export const decodeFontFormat = lookupTable => {
  return {
    fontFamily: fontFamilyByEncodedValue[lookupTable.fontFamily] || FontFamily.DEFAULT,
    fontSize: fontSizeByEncodedValue[lookupTable.fontSize] || "default",
    fontWeight: fontWeightByEncodedValue[lookupTable.fontWeight] || FontWeight.DEFAULT
  };
};
export const encodeFontFormat = decodedFormat => {
  const encodedValuesByFontFormat = {
    fontFamily: encodedValueByFontFamily[decodedFormat.fontFamily],
    fontSize: encodedValueByFontSize[decodedFormat.fontSize],
    fontWeight: encodedValueByFontWeight[decodedFormat.fontWeight]
  };
  return encodedValuesByFontFormat;
};
//# sourceMappingURL=Font.js.map